import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTrainingAuth } from '../context/TrainingAuthContext';
import { Container, Spinner } from 'react-bootstrap';

const TrainingProtectedRoute = ({ children, allowedRoles }) => {
  const { isTrainingAuthenticated, loadingTraining, trainingUser } = useTrainingAuth();

  if (loadingTraining) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="success" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  if (!isTrainingAuthenticated) {
    return <Navigate to="/training-login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(trainingUser?.role)) {
    // Redirect to the appropriate dashboard based on role
    const role = trainingUser?.role;
    const isCoordinator = ['training_coordinator', 'training_document_controller'].includes(role);
    return <Navigate to={isCoordinator ? '/training/coordinator' : '/training/reviewer'} replace />;
  }

  return children;
};

export default TrainingProtectedRoute;
